/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientProcedure from './patient-procedure';
import PatientProcedureDetail from './patient-procedure-detail';
import PatientProcedureUpdate from './patient-procedure-update';
import PatientProcedureDeleteDialog from './patient-procedure-delete-dialog';

const PatientProcedureRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientProcedure />} />
    <Route path="new" element={<PatientProcedureUpdate />} />
    <Route path=":id">
      <Route index element={<PatientProcedureDetail />} />
      <Route path="edit" element={<PatientProcedureUpdate />} />
      <Route path="delete" element={<PatientProcedureDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientProcedureRoutes;
